import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

export interface TopicType { id: number; name: string }

export function getTopicTypes(): Promise<TopicType[]> {
  return apiFetch<TopicType[]>('/topic-types');
}

export function useTopicTypes() {
  return useQuery({ queryKey: ['topic-types'], queryFn: getTopicTypes, staleTime: 60 * 60 * 1000 });
}
